import {Container} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';
import {ISearchAutocompleteItem} from 'types';

import {SearchResultItem} from './components';

interface Props {
  suggestions: ISearchAutocompleteItem[];
  onItemClick: (item: ISearchAutocompleteItem) => void;
  activeSuggestionIndex: number;
  topPadding?: string;
}

export const SearchResults: FC<Props> = ({suggestions = [], activeSuggestionIndex, onItemClick, topPadding}) => {
  const handleItemClick = (item: ISearchAutocompleteItem) => {
    onItemClick(item);
  };

  if (!suggestions?.length) return null;

  return (
    <Container
      variant="white-block"
      position="absolute"
      border="1px solid"
      borderColor={colors.borderGray}
      boxShadow="10px 10px 15px -4px rgba(181,181,181,1)"
      top={topPadding ? topPadding : '46px'}
      maxH="500px"
      overflowY="scroll"
    >
      {suggestions.map((item, index) => (
        <SearchResultItem
          key={index}
          selected={activeSuggestionIndex === index}
          onClick={handleItemClick}
          item={item}
        />
      ))}
    </Container>
  );
};
